import { FC } from 'react';

import AdyenCreditCardForm from 'components/adyen-credit-card-form';
import CreditCardForm from 'components/credit-card-form';
import CreditCardHeader from 'components/credit-card-header';
import { useAppSelector } from 'hooks';
import { effectiveCCType } from 'modules/payment-methods';
import { CREDIT_CARD_ADD_PAY, CREDIT_CARD_SAVE, PAYMENT_METHODS_TYPES } from 'utils/constants';

interface CreditCardAddProps {
  intent: typeof CREDIT_CARD_SAVE | typeof CREDIT_CARD_ADD_PAY;
}

const CreditCardAdd: FC<CreditCardAddProps> = ({ intent }): JSX.Element => {
  const selectedCCType = useAppSelector(effectiveCCType);

  return (
    <>
      <CreditCardHeader />
      {selectedCCType === PAYMENT_METHODS_TYPES.ccAdyen ? (
        <AdyenCreditCardForm intent={intent} />
      ) : (
        <CreditCardForm intent={intent} />
      )}
    </>
  );
};

export default CreditCardAdd;
